import config from './../config'

export const log = (value:any) =>{
    if(config.appEnvironment !== 'PROD') {
		console.log(value)
	}
}